import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import HeroSection from './sections/HeroSection';
import SplitSection from './sections/SplitSection';
import ServicesGrid from './sections/ServicesGrid';
import ResultsCarousel from './sections/ResultsCarousel';
import WhyChooseUs from './sections/WhyChooseUs';
import TestimonialsSection from './sections/TestimonialsSection';
import ContactForm from './sections/ContactForm';
import FAQSection from './sections/FAQSection';
import CTASection from './sections/CTASection';
import AnimatedBackground from './AnimatedBackground';

const LandingPage = () => {
  // Add preload for logo image to prevent flickering
  useEffect(() => {
    const logoImage = new Image();
    logoImage.src = "https://i.postimg.cc/7YGQjLhq/logo-no-background-1.png";
  }, []);

  return (
    <motion.div 
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.7 }}
      className="min-h-screen bg-primary-darkest text-white relative"
      style={{ fontFamily: 'Poppins, Montserrat, sans-serif' }}
    >
      {/* Animated background bubbles */}
      <AnimatedBackground />
      
      {/* Content Sections */}
      <div className="relative z-10">
        <HeroSection />
        <SplitSection />
        <ServicesGrid />
        <ResultsCarousel />
        <WhyChooseUs />
        <TestimonialsSection />
        <ContactForm />
        <FAQSection />
        <CTASection />
      </div>
    </motion.div>
  );
};

export default LandingPage;